import userRoles from './../constants/user-roles';

export default function UserService(
    $window,
    sessionService,
    localStorageService,
    cultureService
) {
    'ngInject';
            const emptyUser = {
                UserId: 0,
                CountryCode: '',
                Contact: 0,
                Name: '',
                Roles: [],
                CurrentCustomerId: 0,
                Department: 0,
                IsHeadOfficeEqualToDepartment: false,
                WorkingHoursRestriction: true,
                OfficeId: '',
            };
            let _user;
            let regionalSettings;

            const DEPARTMENTS_STORAGE_KEY = 'user-departments';
            const DEFAULT_REGIONAL_SETTINGS = {Culture: 'en-GB', Currency: 'GBP', DistanceUnit: 'mi'};

            return {
                saveUserDepartments,
                getUserDepartments,
                setUser,
                getUser,
                getUserName,
                checkPermissions,
                isAdmin,
                isBooker,
                isApprover,
                isTripHolder,
                isFinanceManager,
                isCheckoutAllowed,
                isStandardUser,
                getCurrentDepartment,
                getUserDepartment,
                clearUserSettings,
                clearUser,
                isUSRegion,
                isUKRegion,
                isBERegion,
                getCulture,
                getRegionalSettings,
                getOfficeId,
                getContactId,
                isSeatMapServiceAvailable,
                getCurrencySign,
                getCountry,
            };

            function isSeatMapServiceAvailable() {
                const availableServices = sessionService.getSessionItem('availableServices');
                return availableServices && availableServices.IsSeatMapEnabled
                    || angular.isUndefined(availableServices.IsSeatMapEnabled);
            }

            function user(newUser) {
                if (newUser) {
                    _user = newUser;
                }
                return _user || sessionService.getStorageItem('user') || emptyUser;
            }

            function saveUserDepartments(departments) {
                localStorageService.set(DEPARTMENTS_STORAGE_KEY, departments);
            }

            function getUserDepartments() {
                return _.filter(localStorageService.get(DEPARTMENTS_STORAGE_KEY), {Username: getUserName()});
            }

            function roleExists(role) {
                return (user() && user().Roles && user().Roles.indexOf(role) !== -1);
            }

            function setUser(newUser) {
                user(newUser);
            }

            function getUser() {
                return user();
            }

            function getUserName() {
                return user().Name;
            }

            function getUserId() {
                return user().UserId;
            }

            function checkPermissions(roles) {
                return user().Roles && _.intersection(user().Roles, roles).length;
            }

            function isAdmin() {
                return roleExists(userRoles.ADMIN);
            }

            function isBooker() {
                return roleExists(userRoles.BOOKER);
            }

            function isApprover() {
                return roleExists(userRoles.APPROVER);
            }

            function isTripHolder() {
                return roleExists(userRoles.HOLDER);
            }

            function isFinanceManager() {
                return roleExists(userRoles.FINANCE_MANAGER);
            }

            function isStandardUser() {
                return roleExists(userRoles.STANDARD_USER);
            }

            function isCheckoutAllowed() {
                return isBooker() || isTripHolder();
            }

            function getCurrentDepartment() {
                return user().CurrentCustomerId;
            }

            function getUserDepartment(departmentId) {
                return _.find(getUserDepartments(), {DepartmentId: departmentId});
            }

            function clearUserSettings() {
                regionalSettings = null;
            }

            function clearUser() {
                user(emptyUser);
                sessionService.setSessionItem('user', false);
                $window.localStorage.clear();
            }

            function getCountry() {
                return user().CountryCode.toUpperCase();
            }

            function isUSRegion() {
                return user().CountryCode.toUpperCase() === 'US';
            }

            function isUKRegion() {
                return user().CountryCode.toUpperCase() === 'UK';
            }

            function isBERegion() {
                return user().CountryCode.toUpperCase() === 'BE';
            }

            function getCulture() {
                if (regionalSettings && regionalSettings.culture) {
                    return regionalSettings.culture;
                }

                const services = sessionService.getSessionItem('availableServices');
                return services
                    ? services.RegionalSettings.Culture
                    : 'en-GB';
            }

            function getOfficeId() {
                return user().OfficeId;
            }

            function getContactId() {
                return user().Contact;
            }

            function getCurrencySign() {
                const rs = getRegionalSettings();
                return rs.currencySign;
            }

            function getRegionalSettings() {
                const services = sessionService.getSessionItem('availableServices');
                const settings = services
                    ? services.RegionalSettings
                    : DEFAULT_REGIONAL_SETTINGS;

                const country = getUserId() ? getCountry() : 'UK';
                moment.locale(settings.Culture);
                regionalSettings = cultureService.getCultureSettings(settings, country);

                return regionalSettings;
            }
}



// WEBPACK FOOTER //
// ./src/app/services/userService.js